import React, { useContext, createContext, useState, useEffect } from 'react';

// Constants
const EXPIRATION_TIME = 3600 * 1000; // 1 hour in milliseconds

// Function to get the current time
const getCurrentTime = () => new Date().getTime();

// Function to check if data is expired
const isExpired = (timestamp) => getCurrentTime() - timestamp > EXPIRATION_TIME;

// Create the context
const UserContext = createContext();

// Provider component
const UserProvider = ({ children }) => {
	const getStoredData = (key) => {
		const data = localStorage.getItem(key);
		const timestamp = localStorage.getItem(`${key}_timestamp`);
		if (data && timestamp && !isExpired(Number(timestamp))) {
			return JSON.parse(data);
		} else {
			localStorage.removeItem(key);
			localStorage.removeItem(`${key}_timestamp`);
			return null;
		}
	};

	const [user, setUser] = useState(() => getStoredData('user'));
	const [role, setRole] = useState(() => getStoredData('role'));
	const [isLoggedIn, setIsLoggedIn] = useState(() => getStoredData('isLoggedIn'));
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		if (isLoggedIn) {
			const timestamp = getCurrentTime();
			localStorage.setItem('user', JSON.stringify(user));
			localStorage.setItem('role', JSON.stringify(role));
			localStorage.setItem('isLoggedIn', JSON.stringify(isLoggedIn));

			localStorage.setItem('user_timestamp', timestamp);
			localStorage.setItem('role_timestamp', timestamp);
			localStorage.setItem('isLoggedIn_timestamp', timestamp);
		} else {
			localStorage.removeItem('user');
			localStorage.removeItem('role');
			localStorage.removeItem('isLoggedIn');

			localStorage.removeItem('user_timestamp');
			localStorage.removeItem('role_timestamp');
			localStorage.removeItem('isLoggedIn_timestamp');
		}
	}, [user, role, isLoggedIn]);

	return (
		<UserContext.Provider value={{ user, setUser, role, setRole, isLoggedIn, setIsLoggedIn, showModal, setShowModal }}>
			{children}
		</UserContext.Provider>
	);
};

const useUserContext = () => useContext(UserContext);

export { UserProvider, useUserContext, UserContext };
